// extracted by mini-css-extract-plugin
export default {"ctn":"voice_ctn__HqOR0","textBox":"voice_textBox__jdin2","mask":"voice_mask__tcCdK"};